module.exports = __webpack_public_path__ + "front/img/27_9.fc8031df.png";